import React from 'react'
import { Modal } from 'react-bootstrap'
interface IModalProps {
    show: boolean
    onHide: () => void
    setType: React.Dispatch<React.SetStateAction<number | undefined>>
}
export default function TypeThreeModal({ show, onHide, setType }: IModalProps) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full py-4 px-3">
                <p className=" my-2 text-center">
                    توجه کنید با انتخاب گزینه برنامه های جانبی فرهنگی و امور
                    خیریه
                </p>
                <p className="text-center">
                    بلاعوض برای فیلد بابت، موجودی عضو مورد نظر کاهش نخواهد یافت
                    و تنها موجودی صندوق کاهش می یابد.
                </p>
                <p className="  text-center my-2">
                    آیا از انتخاب این گزینه اطمینان دارید؟
                </p>
                <hr />
                <p
                    className=" text-center text-green-1 my-2"
                    onClick={() => {
                        setType(2)
                        onHide()
                    }}
                >
                    تایید
                </p>
                <hr className=" my-2" />
                <p className=" text-center">بستن</p>
            </div>
        </Modal>
    )
}
